<div class="card load-wrapper rounded-4">
    <div class="activity"></div>
</div>